import Image from "next/image";
import React from "react";
import {s3ImageSource} from "src/useS3ImgSrc";

/**
 * The cover image *should* always be defined but our types are unclear about it.
 * This is the monolith defined default image.
 * https://github.com/mdcollab/monolith-api/blob/af9ab17b112344cea9af147920044ac20f96eed8/api/api-core/src/main/scala/utils/HardcodedDatabaseIds.scala#L120
 */
const DEFAULT_IMAGE = "3ad638a5-cea6-4a4b-b202-808e56e45014";

/**
 * Renders a thumbnail of a provider's coverImage with fixed height, width, and zoom
 */
const ProviderImageThumbnail = ({
  imageId,
  alt = "",
  height = 76,
}: {
  /**
   * The ID of the provider's coverImage
   */
  imageId?: string | null;
  alt?: string;
  height?: 76 | 56;
}) => {
  const id = imageId || DEFAULT_IMAGE;
  const isDefaultImage = id === DEFAULT_IMAGE;

  return (
    <div className="overflow-hidden rounded-[10px] flex items-center">
      <Image
        src={s3ImageSource(id, 1)}
        alt={alt}
        height={height}
        width={height / 1.25}
        className="object-cover"
        style={
          isDefaultImage
            ? undefined
            : {
                scale: "135%",
                objectPosition: `center ${Math.round(height / 9.5)}px`,
              }
        }
      />
    </div>
  );
};

export default React.memo(ProviderImageThumbnail);
